SwiftypeComponents.config = {
  
  search_form: {
    placeholder: "Search",
    onsubmit: [
      { type: 'clear_all', update_results: true, reset_pagination: true },
      { type: "add_param", data: { field: 'q' } }
    ],
    autocomplete: {
      engineKey: "-cRynMTiM8EMyKsTxe8M",
      renderFunction: function(document_type, item) {
        var out = '<div class="ac_result"><div class="ac_image"><img src="' + item['image'] + '" /></div>';
        out = out.concat('<div class="ac_title">'+ item['title'] +'</div>');
        if (item['price']) {
          out = out.concat('<div class="ac_price">$' + item['price'] + '</div>');
        }
        out = out.concat('</div>');
        return out;
      }
    }
  },
  
  sort: {
    sortables: [{ label: "Relevancy",  value: "_score desc" },
                { label: "Price (Lowest first)", value: "price_min asc"   },
                { label: "Price (Highest first)", value: "price_min desc"   },
                { label: "Title (A-Z)", value: "title asc"   },
                { label: "Title (Z-A)", value: "title desc"  }
    ]
  },
  
  routing: {
    onload: function(params){
      return [
        { type: "add_param", data: { field: 'q', value: params.query }, update_results: true }
      ];
    }
  },
  
  pet_facet: {
    title: "Pet Type",
    clear_link: "clear",
    field: 'pet_type',
    and_clause: true,
    disable_checkbox: false,
    sort_by: ['count', 'name'],      // name, count, selected, or function
    sort_by_direction: [false, true] // false = desc, true = asc
  },
  
  category_facet: {
    title: "Category",
    clear_link: "clear",
    field: 'category',
    and_clause: true,
    disable_checkbox: false,
    sort_by: ['count', 'name'],      // name, count, selected, or function
    sort_by_direction: [false, true] // false = desc, true = asc
  },
  
  tags_facet: {
    title: "Tags",
    clear_link: "clear",
    field: 'tags',
    and_clause: true,
    disable_checkbox: false,
    sort_by: ['count', 'name'],      // name, count, selected, or function
    sort_by_direction: [false, true] // false = desc, true = asc
  },
  
  vendor_facet: {
    title: "Brand",
    clear_link: "clear",
    field: 'vendor',
    and_clause: true,
    disable_checkbox: false,
    sort_by: ['count', 'name'],      // name, count, selected, or function
    sort_by_direction: [false, true] // false = desc, true = asc
  },
  
  price_facet: {
    title: "Price",
    clear_link: "clear",
    field: 'price-min',
    and_clause: true,
    disable_checkbox: false,
    sort_by: ['count', 'name'],      // name, count, selected, or function
    sort_by_direction: [false, true] // false = desc, true = asc
  },
  
  pagination: {
    inner_window: 9
  },
  
  result: {
    result_class: "result",
    template_id: "result"
  },

  // An array of stores to save the search results in.
  store_names: ['search'],

  // Default values for all components.
  defaults: {
    store_name: 'search'
  },
  
  // The following defines defaults for the api. For more information see:
  //   https://swiftype.com/documentation/searching
    store_parameters: {
    defaults: {
      apiURL: "https://api.swiftype.com/api/v1/public/engines/search.json",
      engine_key: "-cRynMTiM8EMyKsTxe8M",  // Replace with your engine key.
      page: 1,                             // Start at page 1
      document_type: "page",               // "page" is for crawler based engines
      q: "",                               // Start with no query
      per_page:60,                         // The default page number
      sort_direction: {}                   // Defaults to sorting by relevancy descending
    }
  }
};

                